
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/article/[urlSlug]",
      function () {
        return require("private-next-pages/help/article/[urlSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/article/[urlSlug]"])
      });
    }
  